var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-0 ma-0"},[_c('niko-toggle',{staticClass:"mt-0 mb-6",attrs:{"value":_vm.test.include_ra_rugl_maintenance,"label":_vm.$t('room.illumination.toggle.ra_rugl_maintenance')},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'include_ra_rugl_maintenance',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
      }}}),_c('v-subheader',{staticClass:"mb-1 ml-0 pl-0",staticStyle:{"height":"auto"}},[_vm._v(" "+_vm._s(_vm.$t("room.illumination.preconditions"))+" ")]),_c('niko-textarea',{attrs:{"rows":1,"value":_vm.test.test_requirements,"placeholder":_vm.$t('room.illumination.preconditions')},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'test_requirements',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
      }}}),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.illuminance.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.illuminance.required'),"min":0,"max":1500,"suffix":"lux","step":"1","value":_vm.test.average_illuminance},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'average_illuminance',
          newValue: value,
        };

        _vm.changeIlluminationTestAttribute(options);
      }}}),(_vm.test.include_ra_rugl_maintenance)?_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.illuminance.maintenance_factor'),"min":0,"max":1,"suffix":"fm","step":"0.05","accuracy":0.01,"value":_vm.test.maintenance_factor,"textFieldType":"text"},on:{"onChange":function (valueObj) {
        var options = {
          index: _vm.index,
          attribute: 'maintenance_factor',
          newValue: valueObj.value,
        };

        _vm.changeIlluminationTestAttribute(options);
      }}}):_vm._e(),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.illuminance.deviation'),"subLabel":_vm.$t('room.illumination.illuminance.deviation_info'),"min":0,"max":100,"suffix":"%","step":"1","value":_vm.test.illuminance_deviation},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'illuminance_deviation',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
      }}}),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.uniformity.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.uniformity.required'),"min":0,"max":1,"suffix":"U0","step":"0.05","accuracy":0.01,"value":_vm.test.uniformity,"textFieldType":"text"},on:{"onChange":function (valueObj) {
        var options = {
          index: _vm.index,
          attribute: 'uniformity',
          newValue: valueObj.value,
        };
        _vm.changeIlluminationTestAttribute(options);
      }}}),(_vm.test.include_ra_rugl_maintenance)?_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.ra.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.ra.required'),"min":0,"max":100,"suffix":"Ra","step":"5","value":_vm.test.required_ra},on:{"onChange":function (value) {
          var attributes = ['required_ra', 'measured_ra'];
          attributes.forEach(function (attribute) {
            var options = {
              index: _vm.index,
              attribute: attribute,
              newValue: value,
            };
            _vm.changeIlluminationTestAttribute(options);
          });
        }}}),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.rugl.title")))]),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.rugl.required'),"min":0,"max":40,"step":"1","value":_vm.test.required_rugl},on:{"onChange":function (value) {
          var attributes = ['required_rugl', 'measured_rugl'];
          attributes.forEach(function (attribute) {
            var options = {
              index: _vm.index,
              attribute: attribute,
              newValue: value,
            };
            _vm.changeIlluminationTestAttribute(options);
          });
        }}})],1):_vm._e(),_c('niko-toggle',{staticClass:"mt-4 mb-2",attrs:{"value":_vm.test.include_flicker,"label":_vm.$t('room.illumination.toggle.flicker')},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'include_flicker',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
      }}}),(_vm.test.include_flicker)?_c('div',[_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.flicker.percentage'),"min":-1,"max":100,"suffix":"%","step":"1","value":_vm.test.required_flicker_percentage},on:{"onChange":function (value) {
          var attributes = [
            'required_flicker_percentage',
            'measured_flicker_percentage' ];
          attributes.forEach(function (attribute) {
            var options = {
              index: _vm.index,
              attribute: attribute,
              newValue: value,
            };
            _vm.changeIlluminationTestAttribute(options);
          });
        }}}),_c('niko-slider',{attrs:{"label":_vm.$t('room.illumination.flicker.index'),"min":-0.01,"max":1,"step":"0.01","value":_vm.test.required_flicker_index,"textFieldType":"text"},on:{"onChange":function (value) {
          var attributes = [
            'required_flicker_index',
            'measured_flicker_index' ];
          attributes.forEach(function (attribute) {
            var options = {
              index: _vm.index,
              attribute: attribute,
              newValue: value,
            };
            _vm.changeIlluminationTestAttribute(options);
          });
        }}})],1):_vm._e(),_c('v-btn',{staticClass:"mb-6",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteIlluminationTest(_vm.index)}}},[_c('v-icon',[_vm._v("$iconDelete")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }